module.exports = __webpack_public_path__ + "../resources/images/emptyAttachments-61712cb253b436b6e2ec65493648a370.svg";